import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;

  public setCurrentUrl(url: string): void {
    if (this.currentUrl && this.currentUrl !== url) {
      this.previousUrl = this.currentUrl;
    }

    this.currentUrl = url;
  }

  public getPreviousUrl(): string | null {
    return this.previousUrl;
  }

  public clear(): void {
    this.previousUrl = null;
    this.currentUrl = null;
  }
}
